import { render, staticRenderFns } from "./PatientCancelDuplicate.vue?vue&type=template&id=189e6bd1&scoped=true&"
import script from "./PatientCancelDuplicate.vue?vue&type=script&lang=js&"
export * from "./PatientCancelDuplicate.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "189e6bd1",
  null
  
)

export default component.exports